import React from 'react';

import { Update } from 'src/shared/types/update';

import ProductUpdatesActionItem from './ProductUpdatesActionItem';

interface ProductActionItemListProps {
  updates: Update[];
}

const ProductActionItemList: React.FC<ProductActionItemListProps> = ({
  updates
}) => {
  const renderUpdates = () => {
    return updates.map((update) => (
      <ProductUpdatesActionItem key={update?.id} update={update} />
    ));
  };

  return (
    <div>
      <div className="gap-4 grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))]">
        {renderUpdates()}
      </div>
    </div>
  );
};

export default ProductActionItemList;
